module.exports = __webpack_public_path__ + "img/markerGrey.9c89477b.svg";